import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { AssignmentTurnedIn } from '@material-ui/icons';
import { assign } from 'lodash';

import { Table, Tabela } from '~/components';
import { t, number } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';
import {
  dataInRequest,
  findData,
  recordFiltering,
} from '~/store/modules/afericaoDvec/actions';

import ConfirmDialog from './components/ConfirmDialog';
import * as S from './styles';

function AfericaoList() {
  const dispatch = useDispatch();
  const redux = useSelector((state) => state.afericaoDvec);

  const [loading, setLoading] = useState(false);
  const [handleConfirmModal, setHandleConfirmModal] = useState(false);
  const [item, setItem] = useState();
  const [items, setItems] = useState({
    detalhe: [],
    subdetalhe: [],
  });
  const [subItems, setSubItems] = useState({});

  const handleUpdate = (params = {}) => {
    setHandleConfirmModal(false);
    dispatch(recordFiltering(assign(redux?.params, params)));
  };

  const buttons = useMemo(
    () => [
      {
        title: t('s.geral.aferirdvec'),
        action: () => setHandleConfirmModal(true),
        icon: <AssignmentTurnedIn />,
        disabled:
          item?.statusveiculo === 'L'
            ? item?.afericaodvecveiculo == 'S' ||
              item?.afericaodvecveiculo == 'A' ||
              item?.manutencaodvec == 'S' ||
              item?.tipodvecveiculo === 3
            : 'N',
      },
    ],
    [item]
  );

  const optionsAfericao = useMemo(
    () => [
      { label: 'A', value: t('s.geral.aguardandoatualizacaodvec') },
      { label: 'N', value: t('s.geral.opcoes.nao') },
      { label: 'S', value: t('s.geral.opcoes.sim') },
    ],
    []
  );

  const optionsTipoDvecVeiculo = useMemo(
    () => [
      { label: 0, value: t('Sem Dvec ou não identificado') },
      { label: 1, value: t('Sinal') },
      { label: 2, value: t('CAN Fracionada') },
      { label: 3, value: t('CAN Integral') },
    ],
    []
  );

  const options = useMemo(
    () => [
      { label: 'N', value: t('s.geral.opcoes.nao') },
      { label: 'S', value: t('s.geral.opcoes.sim') },
    ],
    []
  );

  const situation = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const handleSubmit = useCallback(async () => {
    try {
      await api.put(`afericaodvecs/colocar/${item.idveiculo}`);
    } catch (err) {
      console.log(err);
      toast.error(err);
    } finally {
      toast.success(t('s.geral.sucessoalteracao'));
      handleUpdate();
      setHandleConfirmModal(false);
    }
  }, [items]);

  const handleResponseDataItems = useCallback(async (rowValue) => {
    setItem(rowValue);

    try {
      if (rowValue.idveiculo) {
        setLoading(true);

        const response = await api.get(
          `afericaodvecs/detalheafericaodvec/${rowValue.idveiculo}`
        );

        const constSerielzeObj = response.data.detalhe.map((value) => ({
          ...value,
          statusafericaodvec_str: t(value.statusafericaodvec_str),
        }));

        setItems({
          detalhe: constSerielzeObj,
          subdetalhe: [],
        });
      }
    } catch (err) {
      getToastErrors(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleResponseDataSubItems = useCallback(
    async (id) => {
      try {
        if (id) {
          setLoading(true);

          await api
            .get(`afericaodvecs/subdetalheafericaodvec/${id}`)
            .then((response) => setSubItems(response.data));
        }
      } catch (err) {
        getToastErrors(err);
      } finally {
        setLoading(false);
      }
    },
    [subItems, items]
  );

  const header = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.cadastro.veiculo.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.geral.camposistema.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculostr',
        label: t('s.operacao.limpezatag.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.cadastro.veiculo.idmodeloveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'afericaodvecveiculo',
        label: t('s.geral.emafericao'),
        format: (value) =>
          optionsAfericao.find((o) => o.label === value).value || '',
        filter: { type: 'select', options: optionsAfericao },
      },
      {
        id: 'tipodvecveiculo',
        label: t('Tipo DVEC'),
        format: (value) =>
          optionsTipoDvecVeiculo.find((o) => o.label === value).value || '',
        filter: { type: 'select', options: optionsTipoDvecVeiculo },
      },
      {
        id: 'manutencaodvec',
        label: t('s.geral.emmanutencao'),
        format: (value) => options.find((o) => o.label === value).value || '',
        filter: { type: 'select', options },
      },
      {
        id: 'statusveiculo',
        label: t('s.cadastro.veiculo.statusveiculo'),
        format: (value) => situation.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: situation },
      },
    ],
    [options, situation]
  );

  const cellsStock = useMemo(
    () => [
      {
        id: 'datainicioafericaodvec',
        label: t('s.relatorio.geral.datahorainicio'),
      },
      {
        id: 'datafimafericaodvec',
        label: t('s.relatorio.geral.datahorafim'),
      },
      {
        id: 'fatorkinicioafericaodvec',
        label: t('s.geral.fatorkinicio'),
        format: (value) => number(value, 1),
      },
      {
        id: 'fatorkfimafericaodvec',
        label: t('s.geral.fatorkfim'),
        format: (value) => number(value, 1),
      },
      {
        id: 'totalizadorinicioafericaodvec',
        label: t('s.geral.totalizadorinicial'),
        format: (value) => number(value, 1),
      },
      {
        id: 'totalizadorfimafericaodvec',
        label: t('s.geral.totalizadorfinal'),
        format: (value) => number(value, 1),
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.recebimento.idusuario'),
      },
      {
        id: 'statusafericaodvec_str',
        label: t('s.configuracao.posto.statusposto'),
      },
    ],

    []
  );

  const cellsTotal = useMemo(
    () => [
      {
        id: 'dataafericaodvecitem',
        label: t('s.relatorio.descarga.datahora'),
      },
      {
        id: 'totalizadordvecafericaodvecitem',
        label: t('s.geral.totalizadordvec'),
        format: (value) => number(value, 1),
      },
      {
        id: 'totalizadordigitadoafericaodvecitem',
        label: t('s.geral.totalizadordigital'),
        format: (value) => number(value, 1),
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.recebimento.idusuario'),
      },
      {
        id: 'ultimototalizadorconfiguradoafericaodvecitem',
        label: t('s.geral.totalizadorconfigurado'),
        format: (value) => number(value, 1),
      },
    ],

    []
  );

  useEffect(() => {
    if (redux.loading) {
      setItems({});
    }
  }, [redux.loading]);

  useEffect(() => {
    setSubItems({});
  }, [items]);

  return (
    <>
      <S.Container>
        {/* {(redux.loading || loading) && <LinearProgress />} */}
        <Tabela
          read={dataInRequest}
          state={redux}
          noCreate
          noEdition
          header={header}
          onCallback={(value) => handleResponseDataItems(value)}
          headerMobile="nomeempresaveiculostr"
          detach="nomeempresaveiculostr"
          unique={['idveiculo']}
          findItem={findData}
          recordFilter={recordFiltering}
          buttons={buttons}
          size="small"
        />

        <S.Wrapper grids={2}>
          <Table
            isResponsive
            size="small"
            paginate={99}
            showPagination={false}
            cells={cellsStock}
            data={items.detalhe ?? []}
            onRow={(value) => handleResponseDataSubItems(value.idafericaodvec)}
            loading={loading}
            unique={['idafericaodvec']}
          />

          <Table
            isResponsive
            size="small"
            paginate={99}
            showPagination={false}
            cells={cellsTotal}
            data={subItems.subdetalhe ?? []}
            loading={loading}
          />
        </S.Wrapper>
      </S.Container>
      <ConfirmDialog
        open={handleConfirmModal}
        onClose={handleUpdate}
        selectedValue={item}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default AfericaoList;
